import React from 'react';
import c from 'classnames';

import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container, useWindowDimensions } from '@uncinc/uncinc-react-kitchen-sink';

import { SearchTeam } from '../../../components';
import { SCREEN_NORMAL } from '../../../config/constants';
import { GenericParagraphEntity } from '../../../types/uncinc_profile/paragraphs';

export interface ParagraphTeamProps {
  entity: ImmutableEntity<GenericParagraphEntity>;
  className?: string;
}

const ParagraphTeam: React.FC<ParagraphTeamProps> = (props) => {
  const { entity, className } = props;

  const { width } = useWindowDimensions();

  const paragraph = entity.toJS();
  const uuid = paragraph.uuid[0].value;

  const classNames = c('ParagraphTeam', className);

  return (
    <div id={uuid} className={classNames}>
      <SearchTeam routing>
        <Container>
          <div className="mb-10">
            <div className="row">
              <div className="col-12">
                <SearchTeam.SearchBar autoSearch timeout={300} fieldName="search-team" />
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 col-lg-3">
              <SearchTeam.Facets />
              {width < SCREEN_NORMAL && (
                <SearchTeam.ActiveFacets className="mt-2" />
              )}
            </div>

            <div className="col-md-8 col-lg-9">
              <div className="mt-12 mt-md-0">
                <SearchTeam.Results />
              </div>
            </div>
          </div>
        </Container>
      </SearchTeam>
    </div>
  );
};

export default ParagraphTeam;
